import React from 'react'
import Email_image from "assets/images/email.svg"
import { ButtonV1, Image } from 'lib'

const success= () =>{
  return (
   <div className='success_container'>
      <p className='sublabel'>Check your inbox to find the link to reset your password. In case you can’t find the email in your inbox, Please check your spam folder. You will receive the email from ‘KotakTeam’</p>
      <Image imageSrc={Email_image} className="reset"/>
      <ButtonV1 label={"Home"} className="login_button"/>
   </div>
  )
}

export default success